export default "__VITE_ASSET__00c256e2__"